import { ReqParams } from "../types";
import axiosInstance from "./axiosInstance";


export default class NotificationService {
  static async getList(params: ReqParams = {}) {
    const response = await axiosInstance.get("/tenant/notifications", { params });
    return response.data;
  }

  static async markAsRead(params: ReqParams = {}) {
    const response = await axiosInstance.patch(`/tenant/notifications/${params.id}/read`, params);
    return response.data;
  }

  static async getNotificationCount(params: ReqParams = {}) {
    const response = await axiosInstance.get(`/tenant/notifications/count`, params);
    return response.data;
  }

  static async markAllAsRead() {
    const response = await axiosInstance.patch(`/tenant/notifications/read-all`);
    return response.data;
  }
}

